<template>
  <a :href="data.url" class="bg-white hover:bg-blue-50 rounded-md shadow-md p-3 flex">
    <div v-if="data.preview !== null" class="w-full flex-shrink-0" style="width: 100px">
      <img :src="data.preview" alt="" @contextmenu.prevent.stop/>
    </div>
    <div v-else class="w-full text-center flex-shrink-0" style="width: 100px">
      <span class="text-xl lg:text-5xl text-gray-400 font-bold">{{ inicials(data.header)}}</span>
    </div>
    <div class="text-sm pl-5 space-y-1 flex-grow">
      <div class="flex justify-between">
        <h3 class="font-bold break-words" style="word-break: break-word;" v-html="data.header"></h3>
        <span>
          <aw-icon icon="folder" class="w-5 h-5 " />
        </span>
      </div>
      <div class="text-gray-400"><template v-for="(breadcrumb, index) in data.breadcrumbs" :key="index" class="text-gray-400"><template v-if="index > 0"> / </template>{{breadcrumb.name}}</template></div>
      <div>
        <!-- EMPTY -->
      </div>
    </div>
  </a>
</template>

<script>

export default {
  mixins: [
  ],
  props: ['data', 'inicials']
}
</script>